function clHideList(){
  document.querySelectorAll('.testimonial').forEach(elementToToggle => {
    elementToToggle.classList.remove("show");
  });
};

document.addEventListener('DOMContentLoaded', function () {
  const testimonialsList = document.querySelectorAll('ul.cl-testimonials li');
  let index = 1;
  const loop = setInterval(() => { 
      // Verify we're not at the end
      if (index === testimonialsList.length) { 
          index = 0;
      } 
      clHideList(); // hide all
    console.log(testimonialsList[index]) 
    testimonialsList[index].classList.add("show");
    testimonialsList[index++];
    
  }, 8000);
  
}, false);


// -----------------------
// $(function(){
// 	var items = (Math.floor(Math.random() * ($('#testimonials li').length)));
// 	$('#testimonials li').hide().eq(items).show();
	
//   function next(){
// 		$('#testimonials li:visible').delay(5000).fadeOut('slow',function(){
// 			$(this).appendTo('#testimonials ul');
// 			$('#testimonials li:first').fadeIn('slow',next);
//     });
//    }
//   next();
// });